import { render } from "./SectionBackground.vue?vue&type=template&id=1bd9f820&scoped=true"
import script from "./SectionBackground.vue?vue&type=script&lang=js"
export * from "./SectionBackground.vue?vue&type=script&lang=js"

import "./SectionBackground.vue?vue&type=style&index=0&id=1bd9f820&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd9f820"],['__file',"src/scripts/sections/common/SectionBackground.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bd9f820"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bd9f820', __exports__)) {
    api.reload('1bd9f820', __exports__)
  }
  
  module.hot.accept("./SectionBackground.vue?vue&type=template&id=1bd9f820&scoped=true", () => {
    api.rerender('1bd9f820', render)
  })

}


export default __exports__